import { AdvancedPersonWithEReputationStatus } from "src/core/constants/folder";

export type StakeholderDuplicatesReferenceProfile =
  | { type: "current" }
  | { type: "candidate"; candidate: AdvancedPersonWithEReputationStatus }
  | null;

export type StakeholderDuplicatesPayload = {
  stakeholderId: string;
  selectedDuplicateCandidates: AdvancedPersonWithEReputationStatus[];
  referenceProfile: StakeholderDuplicatesReferenceProfile;
};

export const buildStakeholderDuplicatesPayload = ({
  stakeholderId,
  selectedDuplicateCandidates,
  selectedReferenceProfile,
  candidateByDecisionKey,
}: {
  stakeholderId: string;
  selectedDuplicateCandidates: AdvancedPersonWithEReputationStatus[];
  selectedReferenceProfile: { type: "current" } | { type: "candidate"; key: string } | null;
  candidateByDecisionKey: Record<string, AdvancedPersonWithEReputationStatus>;
}): StakeholderDuplicatesPayload => {
  if (selectedReferenceProfile?.type === "candidate") {
    const candidate = candidateByDecisionKey[selectedReferenceProfile.key];

    return {
      stakeholderId,
      selectedDuplicateCandidates,
      referenceProfile: candidate ? { type: "candidate", candidate } : null,
    };
  }

  return {
    stakeholderId,
    selectedDuplicateCandidates,
    referenceProfile: selectedReferenceProfile,
  };
};
